/**
 * Eigenbau: Dringlichkeit als drei Punkte statt als Wort oder Farbe.
 *
 * Der Entwurf zeigt Priorität als Reihe von drei kleinen Quadraten: gesetzte in
 * Tinte, offene in der Ruhefarbe. Kein Wort, keine Farbe, kein Symbol — die
 * Stufe ist auf einen Blick abzählbar und nimmt in einer Zeile fast keinen
 * Platz.
 *
 * Kein Tremor-Gegenstück: `CategoryBar` zeigt Anteile eines Ganzen, `Tracker`
 * gleichartige Läufe über Zeit. Drei Stufen sind die Obergrenze — mehr
 * unterscheidet auf sieben Pixeln niemand.
 *
 * Die Punkte sind dekorativ; die Stufe steht als Text im `title` und muss in
 * der Zeile ohnehin benannt sein, wenn sie eine Rolle spielt.
 */

import { cx } from "@/lib/utils";
import { prioritaet } from "@/lib/entwurf-zustaende";

export function Prioritaetspunkte({
  stufe,
  className,
}: {
  /** 0 bis 3. Alles darüber wird als 3 gezeichnet. */
  stufe: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      title={`Dringlichkeit ${Math.min(Math.max(stufe, 0), 3)} von 3`}
      className={cx("flex flex-none items-center gap-[3px]", className)}
    >
      {prioritaet(stufe).map((farbe, i) => (
        <span key={i} className={cx("block size-[5px]", farbe)} />
      ))}
    </span>
  );
}
